import { TagsDisplay } from "components/TagsDisplay";
import { FilterKey, OmnisearchGridColDef } from "hooks/useOmnisearchDatagrid";

type TaggedStreamRow = { tags: { id: string; name: string }[] };

/** The waste stream grids' Tags column: the stream's own tags. */
export function wasteStreamTagsColumn<Row extends TaggedStreamRow>(): OmnisearchGridColDef<Row> {
  return {
    field: "tags",
    headerName: "Tags",
    sortable: false,
    filterable: false,
    flex: 0.6,
    valueGetter: (_, row) => row.tags.map((tag) => tag.name).join(", "),
    renderCell: ({ row }) => <TagsDisplay tags={row.tags} />,
  };
}

/**
 * The waste stream grids' tag filter. It matches streams by the tags on their
 * lines (each line's own plus its stream's), so a stream can match with an
 * empty Tags cell; hence "Line tags".
 */
export const WASTE_STREAM_LINE_TAGS_FILTER: FilterKey = {
  key: "tags",
  header: "Line tags",
  filterKeyType: "wasteTags",
};
